<template>
	<div class="week-info row">
		<div class="info-column">
			<div class="info-row">
				<p>Assigned Shifts</p>
				<span><strong>27</strong> / 48</span>
			</div>
			<div class="info-row">
				<p>Sales Forecast</p>
				<span><strong>$ 32,000.00</strong></span>
			</div>
			<div class="info-row">
				<div class="wrapper">
					<p>Weekly Budget</p>
					<button>45% UB</button>
				</div>
				<span><strong>$1,250.00</strong> / $3,250.00</span>
			</div>
		</div>
		<div class="info-column">
			<img src="https://via.placeholder.com/230x219?text=D3+Graph" alt="" />
		</div>
	</div>
</template>

<script>
export default {
	name: 'weekInfo',
};
</script>

<style lang="scss" scoped>
.week-info {
	position: absolute;
	top: 70px;
	left: 128px;
	right: 0;
	z-index: 100;

	margin-left: auto;
	margin-right: auto;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	width: 607px;
	padding: 20px;
	box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.2);
	background-color: #ffffff;

	&::before {
		content: '';
		border-style: solid;
		border-width: 4px 15px 10px 0;
		border-color: transparent #fff transparent transparent;
		position: absolute;
		transform: rotate(-34deg);
		top: -7px;
		left: -45px;
		right: 0;
		width: 20px;
		margin-left: auto;
		margin-right: auto;
	}

	.info-column {
		display: flex;
		flex-direction: column;
		.info-row {
			display: flex;
			flex-direction: column;
			align-items: flex-start;
			justify-content: flex-start;
			margin-bottom: 20px;

			.wrapper {
				display: flex;
				flex-direction: row;
				align-items: center;
				justify-content: center;

				button {
					margin-left: 15px;
					padding: 2px 10px;
					font-size: 11px;
					border-radius: 3.4px;
					border-color: transparent;
					color: #fff;
					background-color: #79abda;
				}
			}

			p {
				font-size: 12px;
				color: #616e84;
				margin-bottom: 0;
			}
			span {
				font-size: 20px;
			}
		}
	}
}
</style>
